export * from "./ClinicsList";
export * from "./ClinicsList.types";
